<template>
    <div>
        <router-link to="/login" >
            <div id="bg" @click="stop = true">
                <div id="img">
                    <img src="./../assets/images/igroove-logo.svg">
                </div>
            </div>
        </router-link>
    </div>
</template>

<script>
  export default {
    data() {
      return {
        stop: false
      }
    },
    created() {
      setTimeout(this.routeChange, 3000)
    },
    methods: {
      routeChange() {
        if(!this.stop) {
          this.$router.push('/login');
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
    @import "../styles/app";
    #bg {
        background-color: $color-primary;
        display: table;
        height: 100%;
        width: 100%;
        #img {
            display: table-cell;
            vertical-align: middle;
            text-align: center;
        }
    }
</style>
